import request from '@/utils/request'

const PREFIX = '/signstore/redbook'

export function fetchRedbookLaunch(params) {
  return request.get(PREFIX + '/launch', { params })
}

export function initRedbookPublish(data) {
  return request.post(PREFIX + '/publish/init', data)
}

export function updateRedbookPublishStatus(data) {
  return request.post(PREFIX + '/publish/status', data)
}

export function fetchXhsShareConfig(data) {
  return request.post(PREFIX + '/publish/xhs-share-config', data)
}
